import { metricsStore } from '@globalStore/metricsStore';

export const createFrustrationSignalPresetLimitations = () => {
  const { frustrationSignalConfigMeta } = metricsStore.getState();
  if (!frustrationSignalConfigMeta) return {};

  const frustrationSignalLimitations = Object.keys(frustrationSignalConfigMeta).reduce(
    (acc, frustrationSignalId) => {
      acc[`frustration-signal-${frustrationSignalId}`] =
        getFrustrationSignalPresetLimitation(frustrationSignalId);
      return acc;
    },
    {} as Record<string, ReturnType<typeof getFrustrationSignalPresetLimitation>>,
  );
  return frustrationSignalLimitations;
};

export const getFrustrationSignalPresetLimitation = (frustrationSignalId: number | string) => {
  const { metricsCategoryKeys, frustrationSignalConfigMeta, metricsGroupedByCategory } =
    metricsStore.getState();
  const currentFrustrationSignalMeta = frustrationSignalConfigMeta?.[frustrationSignalId];

  if (currentFrustrationSignalMeta?.id) {
    // Get all metrics in ECO_FRUSTRATION_SIGNALS category
    const allFrustrationSignalMetrics =
      metricsGroupedByCategory?.app?.ECO_FRUSTRATION_SIGNALS || {};

    // Get metrics that belong to this specific frustration signal
    const currentSignalMetricIds = Object.keys(currentFrustrationSignalMeta.metrics || {});
    const currentSignalMetricKeys = currentSignalMetricIds.map(
      (id) => currentFrustrationSignalMeta.metrics[id],
    );

    // Find metrics in ECO_FRUSTRATION_SIGNALS that DON'T belong to this signal
    const otherFrustrationSignalMetrics = Object.keys(allFrustrationSignalMetrics).filter(
      (metricKey) => !currentSignalMetricKeys.includes(metricKey),
    );

    // Categories to exclude - keep only frustration signals, audience, custom metrics, web and app experience
    const categoriesToExclude = Object.keys(metricsCategoryKeys).filter((categoryKey) => {
      const categoriesToKeep = [
        'ECO_FRUSTRATION_SIGNALS',
        'ECO_AUDIENCE',
        'ECO_USER_DEFINED_METRICS', // Custom metrics
        'ECO_WEB_USER_EXPERIENCE', // Web experience
        'ECO_APP_USER_EXPERIENCE', // Mobile experience
      ];
      return !categoriesToKeep.includes(categoryKey);
    });

    return {
      context: {
        type: 'frustration-signal',
        id: frustrationSignalId,
      },
      metrics: {
        excludeTypes: [],
        excludeKeys: otherFrustrationSignalMetrics, // Exclude other frustration signal metrics
        excludeCategories: categoriesToExclude, // Exclude categories except the ones we want to keep
        config: {
          createCustomMetric: false,
          createFlowMetric: false,
          showPercentile: true,
          showFlow: false,
        },
      },
      dimensions: {
        hiddenKeys: [], // Add specific hidden dimensions for frustration signals if needed
      },
      dimensionPanel: {},
      summaryMetricPanel: {},
    };
  }

  return undefined;
};
